(function() {

    class LinearConfigurator {
        /** @var {HTMLElement} */
        $configurator;

        /** @var {HTMLInputElement} */
        $gridDesign;

        /** @var {HTMLInputElement} */
        $position;

        /** @var {HTMLInputElement} */
        $outfall;

        /** @var {HTMLInputElement} */
        $diameter;

        /** @var {HTMLInputElement} */
        $frame;

        /** @var {HTMLInputElement} */
        $length;

        /** @var {HTMLButtonElement} */
        $submitButton;

        /** @var {object} */
        productsData;


        constructor($configurator, productsData) {
            this.$configurator = $configurator;
            this.productsData  = productsData;
        }

        initialize() {

            this.$configurator.addEventListener('submit', this.onSubmit.bind(this));
        }

        onSubmit(event) {
            event.preventDefault();

            this.$gridDesign = this.$configurator.querySelector('input[name="grid-design"]:checked');
            this.$position = this.$configurator.querySelector('input[name="position"]:checked');
            this.$outfall = this.$configurator.querySelector('input[name="outfall"]:checked');
            this.$diameter = this.$configurator.querySelector('input[name="diameter"]:checked');
            this.$frame = this.$configurator.querySelector('input[name="frame"]:checked');
            this.$length = this.$configurator.querySelector('input[name="length"]:checked');

            if ( !this.$gridDesign ) {
                alert( linConfParams.selectGridType );
            }else if ( !this.$position ) {
                alert( linConfParams.selectPosition );
            } else if ( !this.$outfall ) {
                alert( linConfParams.selectOutlet );
            } else if ( !this.$diameter ) {
                alert( linConfParams.selectOutletDiameter );
            } else if ( !this.$frame ) {
                alert( linConfParams.selectFrameType );
            } else if ( !this.$length ) {
                alert( linConfParams.selectLength );
            } else {
                this.createProduct();
            }
        }

        assignProducts() {
            let wantedProducts = {
                "grid": this.$gridDesign.value,
                "position": this.$position.value,
                "drain": this.$outfall.value,
                "diameter": parseInt( this.$diameter.value ),
                "frame": this.$frame.value,
                "length": parseInt( this.$length.value )
            };

            const wantedProductsKeys = Object.keys( wantedProducts );
            let finalProducts = [];

            productsDataLoop:
            for ( const productData of Object.values( productsData ) ) {
                let productConfig = productData['configurator_info'];

                for ( const paramKey of wantedProductsKeys ) {
                    if ( productConfig[paramKey] !== wantedProducts[paramKey] ) {
                        continue productsDataLoop;
                    }
                }

                finalProducts.push( productData['render_info'] );
            }

            return finalProducts;
        }

        createProduct() {
            let products = this.assignProducts();

            if ( products.length === 0 ) {
                alert( linConfParams.noProductsFound );
                return;
            }

            let $productsContainer = document.querySelector('#product-wrap');
            const $template = document.querySelector('#product-template');
            const $form = document.querySelector('#add_to_cart_form');
            const $input = $form.querySelector('#product_cart');
            const toCartProducts = [];

            if ( $productsContainer.hasChildNodes() ) {
                $productsContainer.innerHTML = "";
            }

            for ( const product of Object.values(products) ) {

                let $product = $template.content.cloneNode(true);
                let $productTitle = $product.querySelector('.product-title');
                let $productPrice = $product.querySelector('.product-price');
                let $productImage = $product.querySelector('.product-image img');
                let $productLink = $product.querySelector('.product-link');

                $productTitle.textContent = product['title'];
                $productImage.src = product['image'];
                $productLink.href = product['link'];

                if ($productPrice) {
                    $productPrice.textContent = Math.round( (product['price'] ) * 100 ) / 100 + " Kč";
                }

                toCartProducts.push({
                    id: product['id'],
                    amount: product['amount']
                });

                $productsContainer.appendChild($product);
            }

            $input.value = JSON.stringify(toCartProducts);
            $form.classList.add('active');
        }

    }

    // Initialize configurator.
    const $configurator = document.querySelector('.linear-form');

    let productsData = $configurator.getAttribute("data-products");
    productsData = JSON.parse(productsData);

    $configurator.conf = new LinearConfigurator($configurator, productsData);
    $configurator.conf.initialize();
})();

let configurationTabs = document.querySelectorAll('.configuration-tab');

for ( let configurationTab of configurationTabs ) {

    let button = configurationTab.querySelector('.configurator-tab-btn');

    button.addEventListener('click', function(e) {
        e.preventDefault();
        let optionsMenu = configurationTab.querySelector('.configuration-tab-menu');

        let activeTab = document.querySelector('.configuration-tab-menu.active');

        if ( activeTab ) {
            activeTab.classList.remove('active');
        }

        optionsMenu.classList.add('active');
    });
}

let gridTypesOptions = document.querySelectorAll('.grid-type-options');

for ( let gridTypesOption of gridTypesOptions ) {
    let button = gridTypesOption.querySelector('.tab-menu-btn');

    button.addEventListener('click', function(e) {
        e.preventDefault();
        let optionsMenu = gridTypesOption.querySelector('.design-options');

        let activeTab = document.querySelector('.design-options.active');
        let activeButton = document.querySelector('.tab-menu-btn.active');

        if ( activeTab ) {
            activeTab.classList.remove('active');
            activeButton.classList.remove('active');
        }

        optionsMenu.classList.add('active');
        button.classList.add('active');
    });
}

let options = document.querySelectorAll('.configuration-tab label');
const inputWrap = document.querySelector('.configurator-text');
let imagePath = '';
const imageLocation = document.querySelector('.configurator-images .grid-image');

    for ( let option of options ) {
    option.addEventListener('click', function() {
        let input = option.querySelector('input');
        let inputId = input.getAttribute('id');
        let inputLabel = input.parentNode;
        let inputMenu = inputLabel.parentNode;
        let activeLabel = inputMenu.querySelector('label.active');
        let inputPlace = inputWrap.querySelector('.' + input.getAttribute('name') + '');

        if ( inputId && inputId.includes('grid-design') ) {
            inputPlace.textContent = input.value;
            inputPlace.parentNode.classList.add('active');

            if ( activeLabel ) {
                activeLabel.classList.remove('active');
                inputLabel.classList.add('active');
            }else {
                inputLabel.classList.add('active');
            }
        }

        if ( input.getAttribute('name') === 'grid-design' || input.getAttribute('name') === 'position' ) {
            $position = document.querySelector('input[name="position"]:checked');
            $activeGrid = document.querySelector('input[name="grid-design"]:checked');

            if ( !$position || $position.value === 'wall' ) {
                imagePath = 'u-steny/' + $activeGrid.getAttribute('data-image') + '.png';
            } else {
                imagePath = 'v-prostoru/' + $activeGrid.getAttribute('data-image') + '.png';
            }

            if ( imagePath ) {
                imageLocation.src= 'https://www.chudej.cz/wp-content/themes/chudej/img/configurator/new/' + imagePath;

                activeImage = document.querySelector('.configurator-images .grid-image.active');

                if ( activeImage ) {
                    activeImage.classList.remove('active');
                    imageLocation.classList.add('active');
                }else{
                    imageLocation.classList.add('active');
                }
            }
        }

        if ( inputPlace && !inputId ) {
            inputPlace.textContent = option.textContent;
            inputPlace.parentNode.classList.add('active');

            if ( activeLabel ) {
                activeLabel.classList.remove('active');
                inputLabel.classList.add('active');
            }else {
                inputLabel.classList.add('active');
            }
        }
    });
}